import styled from 'styled-components'

const CustomerTypeRadioUi = styled.input`
  margin: 0 10px;
`

export default CustomerTypeRadioUi
